import { TableProps } from '@shared/Table'
import { t } from 'i18next'
import { TrustedPersonType } from 'store/types/salaryCard'

type MTrustedPersonType = TrustedPersonType & {
  actions?: any
}

export const trustedColumns: () => TableProps<MTrustedPersonType>['editColumns'] =
  () => ({
    fullName: {
      title: t('orders.salaryCardOrder.inputLabels.fullName'),
      width: 200,
      hasSearch: true,
      fixed: 'left',
    },
    pin: {
      title: t('orders.salaryCardOrder.tableTitles.pin'),
      width: 200,
      hasSearch: true,
    },
    phone: {
      title: t('orders.salaryCardOrder.tableTitles.phoneNumber'),
      width: 200,
      hasSearch: true,
    },
    expiryDate: {
      title: t('orders.salaryCardOrder.tableTitles.expiryDate'),
      width: 200,
      hasSelect: true,
    }
  })
